var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { overflow: "hidden" } },
    [
      _c("div", { staticClass: "body-wrapper-asset" }, [
        _c(
          "div",
          { ref: "container" },
          [
            _c(
              "van-pull-refresh",
              {
                staticClass: "refresh-box pullStyle",
                attrs: {
                  id: "refresh-box",
                  "success-text": "刷新成功",
                  "head-height": 58
                },
                on: { refresh: _vm.onRefresh },
                model: {
                  value: _vm.isLoading,
                  callback: function($$v) {
                    _vm.isLoading = $$v
                  },
                  expression: "isLoading"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "sub-refresh-box" },
                  [
                    _c("div", { staticClass: "serach_box_wrap before" }),
                    _c("div", { staticClass: "serach_box_wrap" }, [
                      _c(
                        "div",
                        {
                          staticClass: "search_box",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.navigationClick("1")
                            }
                          }
                        },
                        [_vm._v(" 请输入产品名称/代码 ")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showWhiteIcon,
                              expression: "showWhiteIcon"
                            }
                          ],
                          staticClass: "icon_box"
                        },
                        [
                          _c("img", {
                            staticClass: "mesg",
                            attrs: {
                              src: require("@/assets/images/icons/msg-2.png"),
                              id: "mesg"
                            },
                            on: {
                              click: function($event) {
                                return _vm.navigationClick("2")
                              }
                            }
                          }),
                          _vm.countMsg > 0
                            ? _c("span", { staticClass: "mesg_after" }, [
                                _vm._v(_vm._s(_vm.countMsg))
                              ])
                            : _vm._e(),
                          _c("img", {
                            staticClass: "phone_icon",
                            attrs: {
                              src: require("@/assets/images/icons/phone_icon_white.png"),
                              id: "phone_icon"
                            },
                            on: {
                              click: function($event) {
                                return _vm.navigationClick("3")
                              }
                            }
                          })
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.showWhiteIcon,
                              expression: "!showWhiteIcon"
                            }
                          ],
                          staticClass: "icon_box"
                        },
                        [
                          _c("img", {
                            staticClass: "mesg",
                            attrs: {
                              src: require("@/assets/images/icons/msg_black.png"),
                              id: "mesg"
                            },
                            on: {
                              click: function($event) {
                                return _vm.navigationClick("2")
                              }
                            }
                          }),
                          _vm.countMsg > 0
                            ? _c("span", { staticClass: "mesg_after" }, [
                                _vm._v(_vm._s(_vm.countMsg))
                              ])
                            : _vm._e(),
                          _c("img", {
                            staticClass: "phone_icon",
                            attrs: {
                              src: require("@/assets/images/icons/phone_black2.png"),
                              id: "phone_icon"
                            },
                            on: {
                              click: function($event) {
                                return _vm.navigationClick("3")
                              }
                            }
                          })
                        ]
                      )
                    ]),
                    _c("img", {
                      staticClass: "banner",
                      attrs: { src: _vm.bannerUrl }
                    }),
                    _c(
                      "div",
                      { staticClass: "blank-wrp" },
                      [
                        _c("div", { staticClass: "des" }, [
                          _c(
                            "div",
                            {
                              staticClass: "des-flex",
                              on: { click: _vm.eyesClick }
                            },
                            [
                              _vm._v(" 总资产(元) "),
                              _vm.eyeIsShow
                                ? _c("van-icon", {
                                    staticClass: "vanIconStyle",
                                    attrs: { name: "eye-o", color: "#FFF" }
                                  })
                                : _c("van-icon", {
                                    staticClass: "vanIconStyle",
                                    attrs: { name: "closed-eye", color: "#FFF" }
                                  })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "des-flex right",
                              on: { click: _vm.assetsExplain }
                            },
                            [
                              _vm._v(" 资产说明 "),
                              _c("van-icon", {
                                staticClass: "vanIconStyle",
                                attrs: { name: "question-o", color: "#FFF" }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "total" }, [
                          (_vm.eyeIsShow && !_vm.getDataScuccessed) ||
                          _vm.dataInterfaceError
                            ? _c("span", [_vm._v("计算中")])
                            : _vm.eyeIsShow && _vm.getDataScuccessed
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatMoney")(
                                      _vm.assetsObj.totalAssets
                                    )
                                  )
                                )
                              ])
                            : !_vm.eyeIsShow && _vm.getDataScuccessed
                            ? _c("span", [_vm._v("****")])
                            : _vm._e()
                        ]),
                        _c("div", { staticClass: "jgq" }, [
                          _c(
                            "div",
                            { staticClass: "item alignLeft paddingLeft" },
                            [
                              _vm.eyeIsShow && _vm.getDataScuccessed
                                ? _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "color-if",
                                          rawName: "v-color-if",
                                          value: _vm.assetsObj.totalIncome,
                                          expression: "assetsObj.totalIncome"
                                        }
                                      ],
                                      style: { fontSize: _vm.totalFontSize }
                                    },
                                    [_vm._v(_vm._s(_vm.assetsObj.totalIncome))]
                                  )
                                : _vm.eyeIsShow && !_vm.getDataScuccessed
                                ? _c(
                                    "span",
                                    { style: { fontSize: _vm.totalFontSize } },
                                    [_vm._v("--")]
                                  )
                                : _c("span", [_vm._v("****")]),
                              _vm.exitsStockAndOther
                                ? _c("span", { staticClass: "bottom" }, [
                                    _vm._v("总收益")
                                  ])
                                : _c("span", { staticClass: "bottom" }, [
                                    _vm._v("累计收益")
                                  ])
                            ]
                          ),
                          _c("div", { staticClass: "item" }, [
                            _vm.eyeIsShow
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "color-if",
                                        rawName: "v-color-if",
                                        value: _vm.assetsObj.totalReturn,
                                        expression: "assetsObj.totalReturn"
                                      }
                                    ],
                                    style: { fontSize: _vm.totalFontSize }
                                  },
                                  [_vm._v(_vm._s(_vm.assetsObj.totalReturn))]
                                )
                              : _c("span", [_vm._v("****")]),
                            _vm.exitsStockAndOther
                              ? _c("span", { staticClass: "bottom" }, [
                                  _vm._v("实现收益")
                                ])
                              : _c("span", { staticClass: "bottom" }, [
                                  _vm._v("清仓收益")
                                ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "item alignRight paddingRight" },
                            [
                              _vm.eyeIsShow
                                ? _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "color-if",
                                          rawName: "v-color-if",
                                          value:
                                            _vm.assetsObj.totalFloatingProfit,
                                          expression:
                                            "assetsObj.totalFloatingProfit"
                                        }
                                      ],
                                      style: { fontSize: _vm.totalFontSize }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.assetsObj.totalFloatingProfit
                                        )
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("****")]),
                              _c("span", { staticClass: "bottom" }, [
                                _vm._v("浮动盈亏")
                              ])
                            ]
                          )
                        ]),
                        _vm.messageList && _vm.baseInfoFromNative.company == "5"
                          ? _c("van-notice-bar", {
                              staticClass: "newsBar",
                              attrs: {
                                color: "#333",
                                background: "#fff",
                                "left-icon": "volume-o",
                                text: _vm.messageList,
                                scrollable: ""
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("div", { staticClass: "title" }, [
                      _vm._v("资产明细(元)")
                    ]),
                    _vm.baseInfoFromNative.company == "1"
                      ? _c(
                          "div",
                          {
                            staticClass: "card-wrap",
                            on: {
                              click: function($event) {
                                return _vm.assetsDetailClick("1")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "top" }, [
                              _vm._v("公募基金 "),
                              _vm.eyeIsShow
                                ? _c("span", { staticClass: "top-right" }, [
                                    _vm._v("(存续规模："),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.assetsObj.publicOfferingDto
                                              .totalAmount
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(")")
                                  ])
                                : _c("span", { staticClass: "top-right" }, [
                                    _vm._v("(存续规模：****)")
                                  ])
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "wrap-item",
                                style: {
                                  marginTop:
                                    _vm.assetsObj.publicOfferingDto
                                      .numberOfOrdersInTransit &&
                                    _vm.assetsObj.publicOfferingDto
                                      .numberOfOrdersInTransit > 0
                                      ? "0.32rem"
                                      : "0.24rem"
                                }
                              },
                              [
                                _c("div", { staticClass: "item alignLeft" }, [
                                  _vm.eyeIsShow
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "color-if",
                                              rawName: "v-color-if",
                                              value:
                                                _vm.assetsObj.publicOfferingDto
                                                  .yesterdaySEarnings,
                                              expression:
                                                "assetsObj.publicOfferingDto.yesterdaySEarnings"
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.assetsObj.publicOfferingDto
                                                .yesterdaySEarnings
                                            )
                                          )
                                        ]
                                      )
                                    : _c("span", [_vm._v("****")]),
                                  _c("span", { staticClass: "bottom" }, [
                                    _vm._v("昨日收益")
                                  ])
                                ]),
                                _vm.assetsObj.publicOfferingDto
                                  .numberOfOrdersInTransit &&
                                _vm.assetsObj.publicOfferingDto
                                  .numberOfOrdersInTransit > 0
                                  ? _c("div", { staticClass: "onway-order" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.assetsObj.publicOfferingDto
                                              .numberOfOrdersInTransit
                                          ) +
                                          "笔在途订单 "
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item alignRight" }, [
                                  _vm.eyeIsShow
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "color-if",
                                              rawName: "v-color-if",
                                              value:
                                                _vm.assetsObj.publicOfferingDto
                                                  .positionIncome,
                                              expression:
                                                "assetsObj.publicOfferingDto.positionIncome"
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.assetsObj.publicOfferingDto
                                                .positionIncome
                                            )
                                          )
                                        ]
                                      )
                                    : _c("span", [_vm._v("****")]),
                                  _c("span", { staticClass: "bottom" }, [
                                    _vm._v("持有收益")
                                  ])
                                ])
                              ]
                            ),
                            _c("div", { staticClass: "divide" }),
                            _c("div", { staticClass: "wrap-item" }, [
                              _c("div", { staticClass: "item alignLeft" }, [
                                _vm.eyeIsShow
                                  ? _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "color-if",
                                            rawName: "v-color-if",
                                            value:
                                              _vm.assetsObj.publicOfferingDto
                                                .floatingProfitAndLoss,
                                            expression:
                                              "assetsObj.publicOfferingDto.floatingProfitAndLoss"
                                          }
                                        ],
                                        style: { fontSize: _vm.pubFontSize }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.assetsObj.publicOfferingDto
                                              .floatingProfitAndLoss
                                          )
                                        )
                                      ]
                                    )
                                  : _c("span", [_vm._v("****")]),
                                _c("span", { staticClass: "bottom" }, [
                                  _vm._v("浮动盈亏")
                                ])
                              ]),
                              _c("div", { staticClass: "item" }, [
                                _vm.eyeIsShow
                                  ? _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "color-if",
                                            rawName: "v-color-if",
                                            value:
                                              _vm.assetsObj.publicOfferingDto
                                                .realizedReturn,
                                            expression:
                                              "assetsObj.publicOfferingDto.realizedReturn"
                                          }
                                        ],
                                        style: { fontSize: _vm.pubFontSize }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.assetsObj.publicOfferingDto
                                              .realizedReturn
                                          )
                                        )
                                      ]
                                    )
                                  : _c("span", [_vm._v("****")]),
                                _c("span", { staticClass: "bottom" }, [
                                  _vm._v("清仓收益")
                                ])
                              ]),
                              _c("div", { staticClass: "item alignRight" }, [
                                _vm.eyeIsShow
                                  ? _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "color-if",
                                            rawName: "v-color-if",
                                            value:
                                              _vm.assetsObj.publicOfferingDto
                                                .cumulativeIncome,
                                            expression:
                                              "assetsObj.publicOfferingDto.cumulativeIncome"
                                          }
                                        ],
                                        style: { fontSize: _vm.pubFontSize }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.assetsObj.publicOfferingDto
                                              .cumulativeIncome
                                          )
                                        )
                                      ]
                                    )
                                  : _c("span", [_vm._v("****")]),
                                _c("span", { staticClass: "bottom" }, [
                                  _vm._v("累计收益")
                                ])
                              ])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "card-wrap extend",
                        style: {
                          paddingBottom: !_vm.showEntry ? "0.16rem" : "0"
                        },
                        on: {
                          click: function($event) {
                            return _vm.assetsDetailClick("2")
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "top" }, [
                          _vm._v("私募证券 "),
                          _vm.eyeIsShow
                            ? _c("span", { staticClass: "top-right" }, [
                                _vm._v("(存续规模："),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatMoney")(
                                        _vm.assetsObj.privateEquityDto
                                          .totalAmount
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(")")
                              ])
                            : _c("span", { staticClass: "top-right" }, [
                                _vm._v("(存续规模：****)")
                              ])
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "wrap-item",
                            style: {
                              marginTop:
                                _vm.assetsObj.privateEquityDto.orderInTransit &&
                                _vm.assetsObj.privateEquityDto.orderInTransit >
                                  0
                                  ? "0.32rem"
                                  : "0.24rem"
                            }
                          },
                          [
                            _c("div", { staticClass: "item alignLeft" }, [
                              _vm.eyeIsShow
                                ? _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "color-if",
                                          rawName: "v-color-if",
                                          value:
                                            _vm.assetsObj.privateEquityDto
                                              .floatingProfit,
                                          expression:
                                            "assetsObj.privateEquityDto.floatingProfit"
                                        }
                                      ],
                                      style: { fontSize: _vm.priFontSize }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.assetsObj.privateEquityDto
                                            .floatingProfit
                                        )
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("****")]),
                              _c("span", { staticClass: "bottom" }, [
                                _vm._v("浮动盈亏")
                              ])
                            ]),
                            _c("div", { staticClass: "item" }, [
                              _vm.eyeIsShow
                                ? _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "color-if",
                                          rawName: "v-color-if",
                                          value:
                                            _vm.assetsObj.privateEquityDto
                                              .realizedReturn,
                                          expression:
                                            "assetsObj.privateEquityDto.realizedReturn"
                                        }
                                      ],
                                      style: { fontSize: _vm.priFontSize }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.assetsObj.privateEquityDto
                                            .realizedReturn
                                        )
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("****")]),
                              _c("span", { staticClass: "bottom" }, [
                                _vm._v("清仓收益")
                              ])
                            ]),
                            _vm.assetsObj.privateEquityDto.orderInTransit &&
                            _vm.assetsObj.privateEquityDto.orderInTransit > 0
                              ? _c("div", { staticClass: "onway-order" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.assetsObj.privateEquityDto
                                          .orderInTransit
                                      ) +
                                      "笔在途订单 "
                                  )
                                ])
                              : _vm._e(),
                            _c("div", { staticClass: "item alignRight" }, [
                              _vm.eyeIsShow
                                ? _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "color-if",
                                          rawName: "v-color-if",
                                          value:
                                            _vm.assetsObj.privateEquityDto
                                              .cumulativeIncome,
                                          expression:
                                            "assetsObj.privateEquityDto.cumulativeIncome"
                                        }
                                      ],
                                      style: { fontSize: _vm.priFontSize }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.assetsObj.privateEquityDto
                                            .cumulativeIncome
                                        )
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("****")]),
                              _c("span", { staticClass: "bottom" }, [
                                _vm._v("累计收益")
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showEntry,
                                expression: "showEntry"
                              }
                            ],
                            staticClass: "investment_analysis_block"
                          },
                          [
                            _c("div", { staticClass: "block-left" }, [
                              _c("img", {
                                attrs: {
                                  src: require("@assets/images/assets/icon20250509001.png")
                                }
                              })
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "block-right",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.investmentAnalysisClick($event)
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v("精准分析持仓，收益尽在掌握")
                                ]),
                                _c("img", {
                                  attrs: {
                                    src: require("@assets/images/assets/right-yellow.png")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm.baseInfoFromNative.company == "1" && _vm.exitStock
                      ? _c(
                          "div",
                          {
                            staticClass: "card-wrap",
                            on: {
                              click: function($event) {
                                return _vm.assetsDetailClick("3")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "top" }, [
                              _vm._v("私募股权 "),
                              _vm.eyeIsShow
                                ? _c("span", { staticClass: "top-right" }, [
                                    _vm._v("(实缴金额："),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.assetsObj.equityDto.totalAmount
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(")")
                                  ])
                                : _c("span", { staticClass: "top-right" }, [
                                    _vm._v("(实缴金额：****)")
                                  ])
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "wrap-item",
                                style: {
                                  marginTop:
                                    _vm.assetsObj.equityDto.orderInTransit &&
                                    _vm.assetsObj.equityDto.orderInTransit > 0
                                      ? "0.32rem"
                                      : "0.24rem"
                                }
                              },
                              [
                                _c("div", { staticClass: "item alignLeft" }, [
                                  _vm.eyeIsShow
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "color-if",
                                              rawName: "v-color-if",
                                              value:
                                                _vm.assetsObj.equityDto
                                                  .amountReturned,
                                              expression:
                                                "assetsObj.equityDto.amountReturned"
                                            }
                                          ],
                                          style: { fontSize: _vm.stockFontSize }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.assetsObj.equityDto
                                                .amountReturned
                                            )
                                          )
                                        ]
                                      )
                                    : _c("span", [_vm._v("****")]),
                                  _c("span", { staticClass: "bottom" }, [
                                    _vm._v("已回款金额")
                                  ])
                                ]),
                                _c("div", { staticClass: "item" }, [
                                  _vm.eyeIsShow
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "color-if",
                                              rawName: "v-color-if",
                                              value:
                                                _vm.assetsObj.equityDto
                                                  .realizedReturn,
                                              expression:
                                                "assetsObj.equityDto.realizedReturn"
                                            }
                                          ],
                                          style: { fontSize: _vm.stockFontSize }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.assetsObj.equityDto
                                                .realizedReturn
                                            )
                                          )
                                        ]
                                      )
                                    : _c("span", [_vm._v("****")]),
                                  _c("span", { staticClass: "bottom" }, [
                                    _vm._v("已回款收益")
                                  ])
                                ]),
                                _vm.assetsObj.equityDto.orderInTransit &&
                                _vm.assetsObj.equityDto.orderInTransit > 0
                                  ? _c("div", { staticClass: "onway-order" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.assetsObj.equityDto
                                              .orderInTransit
                                          ) +
                                          "笔在途订单 "
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item alignRight" }, [
                                  _vm.eyeIsShow
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "color",
                                              rawName: "v-color",
                                              value:
                                                _vm.assetsObj.equityDto
                                                  .investmentRecoveryRate,
                                              expression:
                                                "assetsObj.equityDto.investmentRecoveryRate"
                                            }
                                          ],
                                          style: { fontSize: _vm.stockFontSize }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.assetsObj.equityDto
                                                .investmentRecoveryRate
                                            )
                                          )
                                        ]
                                      )
                                    : _c("span", [_vm._v("****")]),
                                  _c("span", { staticClass: "bottom" }, [
                                    _vm._v("投资回款率")
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.baseInfoFromNative.company == "1" && _vm.exitOther
                      ? _c(
                          "div",
                          {
                            staticClass: "card-wrap",
                            on: {
                              click: function($event) {
                                return _vm.assetsDetailClick("4")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "top" }, [
                              _vm._v("其他产品 "),
                              _vm.eyeIsShow
                                ? _c("span", { staticClass: "top-right" }, [
                                    _vm._v("(未回款金额："),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.assetsObj.otherFundsDto
                                              .totalAmount
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(")")
                                  ])
                                : _c("span", { staticClass: "top-right" }, [
                                    _vm._v("(未回款金额：****)")
                                  ])
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "wrap-item",
                                style: {
                                  marginTop:
                                    _vm.assetsObj.otherFundsDto
                                      .orderInTransit &&
                                    _vm.assetsObj.otherFundsDto.orderInTransit >
                                      0
                                      ? "0.32rem"
                                      : "0.24rem"
                                }
                              },
                              [
                                _c("div", { staticClass: "item alignLeft" }, [
                                  _vm.eyeIsShow
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "color-if",
                                              rawName: "v-color-if",
                                              value:
                                                _vm.assetsObj.otherFundsDto
                                                  .amountReturned,
                                              expression:
                                                "assetsObj.otherFundsDto.amountReturned"
                                            }
                                          ],
                                          style: { fontSize: _vm.otherFontSize }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.assetsObj.otherFundsDto
                                                .amountReturned
                                            )
                                          )
                                        ]
                                      )
                                    : _c("span", [_vm._v("****")]),
                                  _c("span", { staticClass: "bottom" }, [
                                    _vm._v("已回款金额")
                                  ])
                                ]),
                                _c("div", { staticClass: "item" }, [
                                  _vm.eyeIsShow
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "color-if",
                                              rawName: "v-color-if",
                                              value:
                                                _vm.assetsObj.otherFundsDto
                                                  .realizedReturn,
                                              expression:
                                                "assetsObj.otherFundsDto.realizedReturn"
                                            }
                                          ],
                                          style: { fontSize: _vm.otherFontSize }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.assetsObj.otherFundsDto
                                                .realizedReturn
                                            )
                                          )
                                        ]
                                      )
                                    : _c("span", [_vm._v("****")]),
                                  _c("span", { staticClass: "bottom" }, [
                                    _vm._v("已回款收益")
                                  ])
                                ]),
                                _vm.assetsObj.otherFundsDto.orderInTransit &&
                                _vm.assetsObj.otherFundsDto.orderInTransit > 0
                                  ? _c("div", { staticClass: "onway-order" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.assetsObj.otherFundsDto
                                              .orderInTransit
                                          ) +
                                          "笔在途订单 "
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item alignRight" }, [
                                  _vm.eyeIsShow
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "color",
                                              rawName: "v-color",
                                              value:
                                                _vm.assetsObj.otherFundsDto
                                                  .investmentRecoveryRate,
                                              expression:
                                                "assetsObj.otherFundsDto.investmentRecoveryRate"
                                            }
                                          ],
                                          style: { fontSize: _vm.otherFontSize }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.assetsObj.otherFundsDto
                                                .investmentRecoveryRate
                                            )
                                          )
                                        ]
                                      )
                                    : _c("span", [_vm._v("****")]),
                                  _c("span", { staticClass: "bottom" }, [
                                    _vm._v("投资回款率")
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "menu-wrap" },
                      _vm._l(_vm.menuList, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.value,
                            staticClass: "icon-item",
                            on: {
                              click: function($event) {
                                return _vm.menuClick(
                                  item.name,
                                  item.link,
                                  item.source
                                )
                              }
                            }
                          },
                          [
                            _c("img", { attrs: { src: item.photoUrl } }),
                            _c("span", [_vm._v(_vm._s(item.name))]),
                            item.name == "我的待办" && _vm.remindCount > 0
                              ? _c(
                                  "span",
                                  { class: { todo: item.name == "我的待办" } },
                                  [_vm._v(_vm._s(_vm.remindCount))]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _c("div", { staticClass: "flex-wrap" }, [
                      !_vm.shotLoading
                        ? _c(
                            "div",
                            {
                              staticClass: "savePhoto left",
                              class: { redBg: !_vm.isInvestmentReportShow },
                              on: { click: _vm.saveScreenShot }
                            },
                            [_vm._v("一键保存长图")]
                          )
                        : _vm._e(),
                      _vm.isInvestmentReportShow
                        ? _c(
                            "div",
                            {
                              staticClass: "savePhoto",
                              on: { click: _vm.queryAssetReport }
                            },
                            [_vm._v("查看资产报告")]
                          )
                        : _vm._e()
                    ]),
                    _vm.baseInfoFromNative.company == "1"
                      ? [
                          _c("p", { staticClass: "bottom-tip top24" }, [
                            _vm._v(
                              " 声明：本页面产品信息及持仓数据仅供投资者参考，请投资者以基金管理人及份额登记机构、基金托管人或估值核算机构发布的具体数据为准。如有疑问，请及时联系客服。 "
                            )
                          ]),
                          _c("p", { staticClass: "bottom-tip top16" }, [
                            _vm._v("市场有风险，投资需谨慎")
                          ]),
                          _c("p", { staticClass: "bottom-tip" }, [
                            _vm._v("基金销售服务由上海陆享基金销售有限公司提供")
                          ])
                        ]
                      : [_c("div", { staticClass: "prop-wrap" })]
                  ],
                  2
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm.baseInfoFromNative.company == "1"
        ? [
            _vm.exitsStockAndOther
              ? _c("tips", {
                  ref: "tipComponent",
                  attrs: { content: _vm.tipsContentByAll },
                  on: { closeTips: _vm.closeTipChange }
                })
              : _c("tips", {
                  ref: "tipComponent",
                  attrs: { content: _vm.tipsContent },
                  on: { closeTips: _vm.closeTipChange }
                })
          ]
        : [
            _c("tips", {
              ref: "tipComponent",
              attrs: { content: _vm.tipsContentByhzlx },
              on: { closeTips: _vm.closeTipChange }
            })
          ],
      _vm.shotLoading
        ? _c("div", { staticClass: "assets-loading" }, [
            _c(
              "div",
              { staticClass: "wrapperL" },
              [
                _c(
                  "van-loading",
                  {
                    staticClass: "loadingS",
                    attrs: {
                      size: "36px",
                      type: "spinner",
                      color: "#fff",
                      "text-color": "#fff",
                      vertical: ""
                    }
                  },
                  [_vm._v("截图中")]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }